import { Alert, Center, Loader, Stack } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { dashboardApi } from "../../lib/api";
import { DashboardGrid } from "./DashboardGrid";

export function DynamicDashboard() {
  const catalogQuery = useQuery({
    queryKey: ["dashboard-catalog"],
    queryFn: () => dashboardApi.catalog(),
  });

  if (catalogQuery.isLoading) {
    return (
      <Center h="var(--axio-unit-200)">
        <Loader color="violet" />
      </Center>
    );
  }

  if (catalogQuery.isError) {
    return (
      <Alert color="red" title="Dashboard unavailable">
        {catalogQuery.error instanceof Error ? catalogQuery.error.message : "Could not load dashboard reports."}
      </Alert>
    );
  }

  const catalog = catalogQuery.data;
  if (!catalog || catalog.reports.length === 0) {
    return (
      <Alert color="yellow" title="No dashboard reports">
        Dashboard reports have not been seeded yet. Run the seed SQL script on the backend database.
      </Alert>
    );
  }

  return (
    <Stack gap="md">
      <DashboardGrid catalog={catalog} />
    </Stack>
  );
}
